// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos exclusivos de la vista Tráfico. No modificar reglas globales del proyecto. */
.trafico-page,
.trafico-page * {
  box-sizing: border-box;
}

.trafico-responsive-loader {
  display: none;
}

.trafico-page.is-device-action-loading,
.trafico-page.is-device-action-loading * {
  cursor: wait !important;
}

@media (max-width: 1199px) {
  .trafico-responsive-loader {
    position: fixed;
    inset: 0;
    z-index: 14000;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    background: rgba(247, 250, 253, .9);
    color: #174263;
    font-size: 14px;
    font-weight: 700;
    backdrop-filter: blur(3px);
  }

  .trafico-responsive-spinner {
    width: 42px;
    height: 42px;
    border: 4px solid #d7e6f1;
    border-top-color: #006699;
    border-radius: 50%;
    animation: trafico-responsive-spin .8s linear infinite;
  }

  @keyframes trafico-responsive-spin {
    to { transform: rotate(360deg); }
  }
}

.trafico-page .trafico-mobile-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin-right: 8px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #006699;
  font-size: 25px;
  cursor: pointer;
}

.trafico-page .trafico-mobile-menu-toggle:hover,
.trafico-page .trafico-mobile-menu-toggle:focus-visible {
  background: #eaf4fb;
  outline: none;
}

.trafico-page .trafico-responsive-view {
  display: none;
}

.trafico-page .trafico-responsive-loading {
  display: flex;
  width: 100%;
  min-height: 220px;
  padding: 32px 16px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  color: #42678b;
  font-size: 13px;
  font-weight: 700;
}

.trafico-page .trafico-tablet-list,
.trafico-page .trafico-mobile-list,
.trafico-page .trafico-mobile-bottom-nav {
  display: none;
}

.trafico-page .trafico-alerts-mobile-heading,
.trafico-page .trafico-alerts-summary {
  display: none;
}

.trafico-page .trafico-alerts-grid {
  display: contents;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .trafico-page .trafico-mobile-menu-toggle {
    display: inline-flex;
  }

  .trafico-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .trafico-page #layout-navbar .app-brand-link img {
    height: 56px !important;
    max-width: 190px;
    object-fit: contain;
  }
}

@media (max-width: 767px) {
  .trafico-page .trafico-mobile-menu-toggle {
    display: inline-flex;
  }

  .trafico-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .trafico-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .trafico-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
    object-fit: contain;
    object-position: left center;
  }

  .trafico-page #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .trafico-page #layout-navbar .navbar-actions {
    gap: 4px;
  }
}

@media (max-width: 1199px) {
  .trafico-alerts-toolbar {
    transform: none;
  }

  .trafico-company-filter {
    width: 260px;
    min-width: 220px;
  }
}

@media (max-width: 767px) {
  .trafico-page #FilterIconTrafico {
    flex-wrap: wrap !important;
  }

  .trafico-page #FilterIconTrafico .trafico-company-filter,
  .trafico-page #FilterIconTrafico .FilterSearchTraficc {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    margin: 0 0 8px !important;
  }
}

/* En Tráfico el sidebar fijo se convierte en drawer al activar el hamburger. */
@media (max-width: 1199px) {
  body.trafico-responsive-page #root {
    margin-left: 0 !important;
  }

  body.trafico-responsive-page .trafico-responsive-offcanvas {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: auto;
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh;
    z-index: 13000;
    box-sizing: border-box;
  }

  body.trafico-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }

  body.trafico-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width 0.2s ease, transform 0.2s ease;
  }

  body.trafico-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, 0.22);
  }

  body.trafico-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {
    display: block;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .trafico-page .trafico-tablet-list {
    display: block;
    width: 100%;
    overflow: hidden;
    border: 1px solid #d9e5ef;
    border-radius: 10px;
    background: #fff;
  }

  .trafico-page .trafico-mobile-list,
  .trafico-page .trafico-mobile-bottom-nav {
    display: none;
  }

  .trafico-page .trafico-tablet-header,
  .trafico-page .trafico-tablet-row {
    display: grid;
    grid-template-columns: minmax(220px, 1.5fr) minmax(110px, 0.8fr) minmax(180px, 1.25fr) minmax(130px, 0.9fr) minmax(90px, 0.6fr) 44px;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .trafico-page .trafico-tablet-header {
    min-height: 40px;
    padding: 0 12px;
    background: #006699;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
  }

  .trafico-page .trafico-tablet-row {
    min-height: 58px;
    padding: 8px 12px;
    border-top: 1px solid #e4edf4;
    color: #263b50;
    font-size: 13px;
  }

  .trafico-page .trafico-tablet-company,
  .trafico-page .trafico-tablet-cell {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .trafico-page .trafico-tablet-company {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .trafico-page .trafico-tablet-company strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .trafico-page .trafico-tablet-company span {
    color: #006699;
    font-weight: 600;
    text-decoration: underline;
  }

  .trafico-page .trafico-tablet-actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 767px) {
  .trafico-page .trafico-tablet-list {
    display: none;
  }

  .trafico-page .trafico-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .trafico-page .trafico-mobile-card {
    display: block;
    min-width: 0;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(31, 55, 80, 0.08);
    color: #263b50;
  }

  .trafico-page .trafico-mobile-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .trafico-page .trafico-responsive-menu {
    position: relative;
    z-index: 30;
    flex: 0 0 auto;
  }

  .trafico-page .trafico-responsive-menu .dropdown-menu {
    z-index: 2000;
  }

  .trafico-page .trafico-responsive-menu .menu-contratos-toggle {
    position: relative;
    z-index: 31;
    min-width: 30px;
    min-height: 30px;
    touch-action: manipulation;
  }

  .trafico-page .trafico-mobile-company {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 3px;
  }

  .trafico-page .trafico-mobile-company strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #182b3d;
    font-size: 14px;
    font-weight: 700;
  }

  .trafico-page .trafico-mobile-company span {
    color: #006699;
    font-size: 13px;
    font-weight: 700;
    text-decoration: underline;
  }

  .trafico-page .trafico-mobile-meta,
  .trafico-page .trafico-mobile-state-row,
  .trafico-page .trafico-status-icons {
    display: flex;
    align-items: center;
  }

  .trafico-page .trafico-mobile-meta {
    flex-wrap: wrap;
    gap: 8px 18px;
    margin-top: 12px;
    color: #263b50;
    font-size: 13px;
  }

  .trafico-page .trafico-mobile-line {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 10px 0 0;
    font-size: 13px;
  }

  .trafico-page .trafico-mobile-line i,
  .trafico-page .trafico-mobile-state-row i {
    color: #006699;
    font-size: 17px;
  }

  .trafico-page .trafico-mobile-observation {
    display: block;
    margin-top: 12px;
    padding: 9px 10px;
    border-left: 3px solid #4fa3c7;
    border-radius: 0 8px 8px 0;
    background: #f3f8fb;
    color: #31495f;
    font-size: 13px;
  }

  .trafico-page .trafico-mobile-observation-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #24445f;
    line-height: 1.35;
  }

  .trafico-page .trafico-mobile-observation-label i {
    color: #006699;
    font-size: 17px;
    flex: 0 0 auto;
  }

  .trafico-page .trafico-mobile-observation-value {
    min-width: 0;
    margin-top: 5px;
    padding-left: 23px;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .trafico-page .trafico-mobile-state-row {
    justify-content: space-between;
    gap: 12px;
    margin-top: 10px;
    font-size: 13px;
  }

  .trafico-page .trafico-mobile-state-row span:first-child {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .trafico-page .trafico-status-icons {
    flex-wrap: wrap;
    gap: 10px;
    min-height: 28px;
    margin-top: 12px;
  }

  .trafico-page .trafico-status-icons img {
    flex: 0 0 auto;
    object-fit: contain;
  }

  .trafico-page .trafico-mobile-details {
    margin-top: 12px;
    padding: 10px;
    border-radius: 10px;
    background: #eef6fb;
    font-size: 12px;
  }

  .trafico-page .trafico-mobile-details p {
    margin: 4px 0;
  }

  .trafico-page .trafico-mobile-bottom-nav {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1005;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    min-height: 62px;
    padding: 6px 8px calc(6px + env(safe-area-inset-bottom));
    border-top: 1px solid #dce6f2;
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 -4px 16px rgba(31, 55, 80, 0.08);
    transform: translateY(0);
    opacity: 1;
    transition: transform 220ms ease, opacity 180ms ease;
    will-change: transform, opacity;
  }

  .trafico-page .trafico-mobile-bottom-nav.is-hidden {
    transform: translateY(calc(100% + env(safe-area-inset-bottom)));
    opacity: 0;
    pointer-events: none;
  }

  .trafico-page .trafico-mobile-bottom-nav a,
  .trafico-page .trafico-mobile-bottom-nav button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    flex-direction: column;
    gap: 2px;
    border: 0;
    background: transparent;
    color: #647b91;
    font: inherit;
    font-size: 11px;
    text-decoration: none;
  }

  .trafico-page .trafico-mobile-bottom-nav i {
    font-size: 21px;
    line-height: 1;
  }

  .trafico-page .trafico-mobile-bottom-nav .active {
    color: #006699;
    font-weight: 700;
  }

  @media (prefers-reduced-motion: reduce) {
    .trafico-page .trafico-mobile-bottom-nav {
      transition: none;
    }
  }
}

@media (max-width: 767px) {
  .trafico-page {
    min-height: 100dvh;
    background: #f5f7fb;
  }

  .trafico-page .content-wrapper {
    padding: 0 16px calc(86px + env(safe-area-inset-bottom));
  }

  .trafico-page .container-fluid.container-p-y {
    padding-top: 18px !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .trafico-page .container-fluid.container-p-y > .row:first-child {
    display: block;
  }

  .trafico-page .container-fluid.container-p-y > .row:first-child > div {
    width: 100%;
    max-width: 100%;
  }

  .trafico-page .label_trafico {
    display: inline-flex;
    align-items: center;
    margin: 8px 8px 18px 0 !important;
    color: #294663;
    font-size: 22px !important;
    font-weight: 700;
    line-height: 1.2;
  }

  .trafico-page .countersColorsTrafico {
    display: flex;
    justify-content: center;
    align-content: center;
    gap: 12px 10px;
    width: min(100%, 300px);
    max-width: 300px;
    margin: 0 auto 24px;
    padding: 0;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid > div,
  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {
    flex: 0 0 52px;
    width: 52px;
    height: 82px;
    margin: 0;
    border: 1px solid #e4e9f0;
    border-radius: 15px;
    background: #fff;
    box-shadow: 0 5px 14px rgba(37, 61, 86, 0.12);
  }

  .trafico-page .countersColorsTrafico .notification {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
  }

  .trafico-page .countersColorsTrafico .notification img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .trafico-page .countersColorsTrafico .notificationCount {
    position: static;
    width: auto;
    height: auto;
    color: #38516d;
    font-size: 17px;
    line-height: 1;
  }

  .trafico-page #FilterIconTrafico {
    margin: 0 0 20px;
  }

  .trafico-page #FilterIconTrafico .input-group {
    min-height: 52px;
    border: 1px solid #dce5ef;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);
    overflow: hidden;
  }

  .trafico-page #FilterIconTrafico .input-group-text,
  .trafico-page #FilterIconTrafico input {
    border: 0;
    background: #fff;
  }

  .trafico-page #FilterIconTrafico input {
    min-width: 0;
    font-size: 16px;
  }

  .trafico-page #FilterIconTrafico input::placeholder {
    color: #9aabbc;
  }

  .trafico-page #FilterIconTrafico .filterTraficCss button {
    border: 1px solid #7188a0;
    border-radius: 12px;
    background: #fff;
    color: #45627d;
  }

  .trafico-page .trafico-mobile-card {
    padding: 16px;
    border-radius: 20px;
    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.1);
  }

  .trafico-page .trafico-mobile-company strong {
    font-size: 16px;
  }

  .trafico-page .trafico-mobile-company span {
    font-size: 15px;
  }

  .trafico-page .trafico-mobile-meta {
    color: #334d68;
    font-size: 14px;
    font-weight: 500;
  }

  .trafico-page .trafico-mobile-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 12px;
    border-radius: 999px;
    font-weight: 700;
  }

  .trafico-page .trafico-mobile-status::before {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    content: "";
  }

  .trafico-page .trafico-mobile-status.is-moving {
    background: #e7f7ef;
    color: #159447;
  }

  .trafico-page .trafico-mobile-status.is-moving::before {
    background: #159447;
  }

  .trafico-page .trafico-mobile-status.is-stopped {
    background: #fde8ec;
    color: #dc3545;
  }

  .trafico-page .trafico-mobile-status.is-stopped::before {
    background: #dc3545;
  }

  .trafico-page .trafico-mobile-status.is-neutral {
    background: #eef3f7;
    color: #45627d;
  }

  .trafico-page .trafico-mobile-status.is-neutral::before {
    background: #7890a6;
  }

  .trafico-page .trafico-mobile-state-row {
    align-items: center;
  }

  .trafico-page .trafico-mobile-state-row > span:last-child {
    color: #45627d;
    font-size: 14px;
    font-weight: 600;
  }
}

@media (max-width: 1199px) {
  .trafico-page .cardContainerTrafico {
    display: none !important;
  }

  .trafico-page .cardContainerTrafico2 {
    display: block !important;
    width: 100%;
    margin-top: 12px;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .trafico-page .trafico-responsive-view {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
  }

  .trafico-page .trafico-responsive-loading {
    display: flex !important;
    min-height: 240px;
  }

  .trafico-page .trafico-responsive-card {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
    margin: 0;
    padding: 10px 12px;
    border: 1px solid #dce6f2;
    border-radius: 0;
    box-shadow: none;
  }

  .trafico-page .trafico-responsive-card + .trafico-responsive-card {
    border-top: 0;
  }

  .trafico-page .trafico-responsive-card .infoEmpresaContrato {
    display: grid;
    grid-template-columns: minmax(180px, 1.25fr) minmax(110px, 0.8fr) minmax(150px, 1fr) minmax(130px, 0.9fr) minmax(120px, 0.9fr);
    align-items: center;
    gap: 4px 16px;
    flex: 1 1 auto;
    min-width: 0;
  }

  .trafico-page .trafico-responsive-card .opcionesContrato {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  .trafico-page .trafico-responsive-card .opcionesContrato h5,
  .trafico-page .trafico-responsive-card .infoEmpresaContrato p {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .trafico-page .trafico-responsive-card .infoEmpresaContrato span {
    font-weight: 600;
  }

  .trafico-page .trafico-responsive-card .iconsContrato {
    flex: 0 0 auto;
  }

  .trafico-page .trafico-responsive-card .moreInfoStyles {
    flex-basis: 100%;
  }

  .trafico-page .countersColorsTrafico {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    width: 300px;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    overflow-x: visible;
    overflow-y: hidden;
    gap: 8px;
    padding: 4px 2px 8px;
  }

  .trafico-page .countersColorsTrafico {
    display: block;
    width: 100%;
    max-width: 360px;
    margin: 0 auto 18px;
    padding: 14px 12px 12px;
    border: 1px solid #e5edf6;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.06);
    overflow: hidden;
  }

  .trafico-page .countersColorsTrafico > div {
    margin-right: 0;
  }

  .trafico-page .trafico-alerts-mobile-heading {
    display: block;
    margin: 0 0 10px;
    text-align: left;
  }

  .trafico-page .trafico-alerts-mobile-heading h2 {
    margin: 0;
    color: #122f52;
    font-size: 21px;
    font-weight: 800;
    line-height: 1.15;
  }

  .trafico-page .trafico-alerts-mobile-heading p {
    display: none;
  }

  .trafico-page .trafico-alerts-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 44px;
    margin: 0 0 8px;
    padding: 4px 10px;
    border: 1px solid #b9ddff;
    border-radius: 999px;
    background: #edf7ff;
    color: #1265bd;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
  }

  .trafico-page .trafico-alerts-summary:hover,
  .trafico-page .trafico-alerts-summary:focus-visible {
    background: #e3f2ff;
    box-shadow: 0 5px 16px rgba(29, 113, 191, 0.12);
    outline: none;
  }

  .trafico-page .trafico-alerts-summary-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #d8edff;
    font-size: 17px;
  }

  .trafico-page .trafico-alerts-summary-copy {
    display: inline-flex;
    align-items: baseline;
    gap: 5px;
    margin: 0 auto 0 8px;
  }

  .trafico-page .trafico-alerts-summary-copy strong {
    color: #096fd4;
    font-size: 14px;
    line-height: 1;
  }

  .trafico-page .trafico-alerts-summary-copy span {
    color: #42678b;
    font-size: 12px;
    font-weight: 600;
  }

  .trafico-page .trafico-alerts-summary > i {
    flex: 0 0 auto;
    font-size: 18px;
  }

  .trafico-page .trafico-alerts-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    width: 100%;
    max-height: 1000px;
    opacity: 1;
    overflow: hidden;
    transition: max-height 0.2s ease, opacity 0.2s ease, transform 0.2s ease;
  }

  .trafico-page .trafico-alerts-grid.is-compact {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    max-height: 76px;
    padding: 1px 0 4px;
    overflow-x: hidden;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .trafico-page .trafico-alerts-grid.is-compact::-webkit-scrollbar {
    display: none;
  }

  .trafico-page .trafico-alerts-grid.is-expanded {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    max-height: 360px;
    overflow: visible;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid > div,
  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 0;
    height: auto;
    min-height: 66px;
    margin: 0;
    padding: 5px 4px;
    border: 1px solid #e3eaf2;
    border-radius: 11px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(37, 61, 86, 0.09);
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification {
    gap: 2px;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification img,
  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification > .badge,
  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification > .en-vivo-live-dot {
    flex: 0 0 auto;
    transform: scale(0.9);
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification img {
    width: 26px !important;
    height: 26px !important;
    object-fit: contain;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notificationCount {
    font-size: 16px;
    font-weight: 700;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid.is-compact .counterItem {
    flex: 0 0 clamp(68px, 19vw, 74px);
    width: clamp(68px, 19vw, 74px);
    min-height: 66px;
    height: 66px;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem:focus-visible {
    outline: 2px solid #1687e8;
    outline-offset: 2px;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  }

  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem.active {
    border-color: #63afe4;
    background: #e8f4ff;
    box-shadow: 0 4px 12px rgba(0, 102, 153, 0.22);
  }

  .trafico-page #FilterIconTrafico {
    display: flex;
    flex-wrap: nowrap !important;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: 8px;
    margin-bottom: 12px;
  }

  .trafico-page #FilterIconTrafico .FilterSearchTraficc {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0 !important;
  }

  .trafico-page #FilterIconTrafico .filterTraficCss {
    display: flex;
    flex: 0 0 auto;
    gap: 8px;
  }

  .trafico-page #FilterIconTrafico .filterTraficCss button {
    min-width: 44px;
    min-height: 44px;
    margin: 0 !important;
  }
}

@media (max-width: 767px) {
  .trafico-page .trafico-responsive-view {
    gap: 12px;
    padding: 0 12px calc(80px + env(safe-area-inset-bottom));
  }

  /* Compensa el espacio interno del contenedor de resultados para que las
     tarjetas queden visualmente alineadas con el buscador y sus controles. */
  .trafico-page .trafico-mobile-card {
    width: calc(100% + 32px);
    margin-left: -16px;
    box-sizing: border-box;
  }

  .trafico-page .trafico-responsive-card {
    display: block;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(31, 55, 80, 0.08);
  }

  .trafico-page .trafico-responsive-card .opcionesContrato {
    align-items: flex-start;
    gap: 8px;
  }

  .trafico-page .trafico-responsive-card .opcionesContrato h5 {
    font-size: 14px;
    line-height: 1.3;
  }

  .trafico-page .trafico-responsive-card .infoEmpresaContrato p {
    margin: 8px 0 0;
    font-size: 13px;
    line-height: 1.35;
  }

  .trafico-page .trafico-responsive-card .infoEmpresaContrato span,
  .trafico-page .trafico-responsive-card .moreInfoStyles span {
    font-weight: 600;
  }

  .trafico-page .trafico-responsive-card .iconsContrato {
    margin-top: 12px;
  }

  .trafico-page .trafico-responsive-card .moreInfoStyles {
    margin-top: 12px;
  }

  .trafico-page .content-wrapper {
    padding-bottom: calc(72px + env(safe-area-inset-bottom));
  }

}

@media (max-width: 767px) {
  /* Tres filas en móvil: empresas, búsqueda y acciones. */
  .trafico-page #FilterIconTrafico {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .trafico-page #FilterIconTrafico .trafico-company-filter,
  .trafico-page #FilterIconTrafico .FilterSearchTraficc,
  .trafico-page #FilterIconTrafico .filterTraficCss {
    width: 100%;
    min-width: 0;
    flex: 0 0 auto;
    margin: 0 !important;
  }

  .trafico-page #FilterIconTrafico .filterTraficCss {
    justify-content: center;
  }

  .trafico-page #FilterIconTrafico .trafico-company-select__control {
    height: 52px;
    min-height: 52px;
    border: 1px solid #dce5ef !important;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06) !important;
  }

  .trafico-page #FilterIconTrafico .trafico-company-select__value-container,
  .trafico-page #FilterIconTrafico .trafico-company-select__indicators {
    height: 50px;
  }

  .trafico-page #FilterIconTrafico .trafico-company-select__placeholder {
    color: #9aabbc;
    font-size: 16px;
  }

  /* El menú de cada tarjeta debe quedar por encima del selector global. */
  .trafico-page .trafico-company-filter {
    z-index: 10;
  }

  .trafico-page .trafico-responsive-menu {
    position: relative;
    z-index: 5000;
  }

  .trafico-page .trafico-responsive-menu .dropdown-menu {
    z-index: 5001 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/traficoResponsive.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sDAAsD;EACxD;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,oIAAoI;IACpI,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,wDAAwD;IACxD,6BAA6B;IAC7B,qCAAqC;IACrC,8CAA8C;IAC9C,wBAAwB;IACxB,UAAU;IACV,oDAAoD;IACpD,+BAA+B;EACjC;;EAEA;IACE,+DAA+D;IAC/D,UAAU;IACV,oBAAoB;EACtB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;;IAEE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8HAA8H;IAC9H,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4DAA4D;EAC9D;;EAEA;;IAEE,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,wEAAwE;EAC1E;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,QAAQ;EACV;;EAEA;;;IAGE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oFAAoF;EACtF;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,SAAS;IACT,wDAAwD;EAC1D;;EAEA;6EAC2E;EAC3E;IACE,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wDAAwD;EAC1D;;AAEF;;AAEA;EACE,wDAAwD;EACxD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,wDAAwD;EAC1D;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,wEAAwE;EACxE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Estilos exclusivos de la vista Tráfico. No modificar reglas globales del proyecto. */\n.trafico-page,\n.trafico-page * {\n  box-sizing: border-box;\n}\n\n.trafico-responsive-loader {\n  display: none;\n}\n\n.trafico-page.is-device-action-loading,\n.trafico-page.is-device-action-loading * {\n  cursor: wait !important;\n}\n\n@media (max-width: 1199px) {\n  .trafico-responsive-loader {\n    position: fixed;\n    inset: 0;\n    z-index: 14000;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 12px;\n    background: rgba(247, 250, 253, .9);\n    color: #174263;\n    font-size: 14px;\n    font-weight: 700;\n    backdrop-filter: blur(3px);\n  }\n\n  .trafico-responsive-spinner {\n    width: 42px;\n    height: 42px;\n    border: 4px solid #d7e6f1;\n    border-top-color: #006699;\n    border-radius: 50%;\n    animation: trafico-responsive-spin .8s linear infinite;\n  }\n\n  @keyframes trafico-responsive-spin {\n    to { transform: rotate(360deg); }\n  }\n}\n\n.trafico-page .trafico-mobile-menu-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  margin-right: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #006699;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.trafico-page .trafico-mobile-menu-toggle:hover,\n.trafico-page .trafico-mobile-menu-toggle:focus-visible {\n  background: #eaf4fb;\n  outline: none;\n}\n\n.trafico-page .trafico-responsive-view {\n  display: none;\n}\n\n.trafico-page .trafico-responsive-loading {\n  display: flex;\n  width: 100%;\n  min-height: 220px;\n  padding: 32px 16px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 10px;\n  color: #42678b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.trafico-page .trafico-tablet-list,\n.trafico-page .trafico-mobile-list,\n.trafico-page .trafico-mobile-bottom-nav {\n  display: none;\n}\n\n.trafico-page .trafico-alerts-mobile-heading,\n.trafico-page .trafico-alerts-summary {\n  display: none;\n}\n\n.trafico-page .trafico-alerts-grid {\n  display: contents;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .trafico-page .trafico-mobile-menu-toggle {\n    display: inline-flex;\n  }\n\n  .trafico-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .trafico-page #layout-navbar .app-brand-link img {\n    height: 56px !important;\n    max-width: 190px;\n    object-fit: contain;\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-page .trafico-mobile-menu-toggle {\n    display: inline-flex;\n  }\n\n  .trafico-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .trafico-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .trafico-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .trafico-page #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .trafico-page #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .trafico-alerts-toolbar {\n    transform: none;\n  }\n\n  .trafico-company-filter {\n    width: 260px;\n    min-width: 220px;\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-page #FilterIconTrafico {\n    flex-wrap: wrap !important;\n  }\n\n  .trafico-page #FilterIconTrafico .trafico-company-filter,\n  .trafico-page #FilterIconTrafico .FilterSearchTraficc {\n    flex: 1 1 100%;\n    width: 100%;\n    min-width: 0;\n    margin: 0 0 8px !important;\n  }\n}\n\n/* En Tráfico el sidebar fijo se convierte en drawer al activar el hamburger. */\n@media (max-width: 1199px) {\n  body.trafico-responsive-page #root {\n    margin-left: 0 !important;\n  }\n\n  body.trafico-responsive-page .trafico-responsive-offcanvas {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: auto;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh;\n    z-index: 13000;\n    box-sizing: border-box;\n  }\n\n  body.trafico-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n\n  body.trafico-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width 0.2s ease, transform 0.2s ease;\n  }\n\n  body.trafico-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, 0.22);\n  }\n\n  body.trafico-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {\n    display: block;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .trafico-page .trafico-tablet-list {\n    display: block;\n    width: 100%;\n    overflow: hidden;\n    border: 1px solid #d9e5ef;\n    border-radius: 10px;\n    background: #fff;\n  }\n\n  .trafico-page .trafico-mobile-list,\n  .trafico-page .trafico-mobile-bottom-nav {\n    display: none;\n  }\n\n  .trafico-page .trafico-tablet-header,\n  .trafico-page .trafico-tablet-row {\n    display: grid;\n    grid-template-columns: minmax(220px, 1.5fr) minmax(110px, 0.8fr) minmax(180px, 1.25fr) minmax(130px, 0.9fr) minmax(90px, 0.6fr) 44px;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  .trafico-page .trafico-tablet-header {\n    min-height: 40px;\n    padding: 0 12px;\n    background: #006699;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  .trafico-page .trafico-tablet-row {\n    min-height: 58px;\n    padding: 8px 12px;\n    border-top: 1px solid #e4edf4;\n    color: #263b50;\n    font-size: 13px;\n  }\n\n  .trafico-page .trafico-tablet-company,\n  .trafico-page .trafico-tablet-cell {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .trafico-page .trafico-tablet-company {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .trafico-page .trafico-tablet-company strong {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .trafico-page .trafico-tablet-company span {\n    color: #006699;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n\n  .trafico-page .trafico-tablet-actions {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-page .trafico-tablet-list {\n    display: none;\n  }\n\n  .trafico-page .trafico-mobile-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .trafico-page .trafico-mobile-card {\n    display: block;\n    min-width: 0;\n    padding: 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(31, 55, 80, 0.08);\n    color: #263b50;\n  }\n\n  .trafico-page .trafico-mobile-card-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .trafico-page .trafico-responsive-menu {\n    position: relative;\n    z-index: 30;\n    flex: 0 0 auto;\n  }\n\n  .trafico-page .trafico-responsive-menu .dropdown-menu {\n    z-index: 2000;\n  }\n\n  .trafico-page .trafico-responsive-menu .menu-contratos-toggle {\n    position: relative;\n    z-index: 31;\n    min-width: 30px;\n    min-height: 30px;\n    touch-action: manipulation;\n  }\n\n  .trafico-page .trafico-mobile-company {\n    display: flex;\n    min-width: 0;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  .trafico-page .trafico-mobile-company strong {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #182b3d;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .trafico-page .trafico-mobile-company span {\n    color: #006699;\n    font-size: 13px;\n    font-weight: 700;\n    text-decoration: underline;\n  }\n\n  .trafico-page .trafico-mobile-meta,\n  .trafico-page .trafico-mobile-state-row,\n  .trafico-page .trafico-status-icons {\n    display: flex;\n    align-items: center;\n  }\n\n  .trafico-page .trafico-mobile-meta {\n    flex-wrap: wrap;\n    gap: 8px 18px;\n    margin-top: 12px;\n    color: #263b50;\n    font-size: 13px;\n  }\n\n  .trafico-page .trafico-mobile-line {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 10px 0 0;\n    font-size: 13px;\n  }\n\n  .trafico-page .trafico-mobile-line i,\n  .trafico-page .trafico-mobile-state-row i {\n    color: #006699;\n    font-size: 17px;\n  }\n\n  .trafico-page .trafico-mobile-observation {\n    display: block;\n    margin-top: 12px;\n    padding: 9px 10px;\n    border-left: 3px solid #4fa3c7;\n    border-radius: 0 8px 8px 0;\n    background: #f3f8fb;\n    color: #31495f;\n    font-size: 13px;\n  }\n\n  .trafico-page .trafico-mobile-observation-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #24445f;\n    line-height: 1.35;\n  }\n\n  .trafico-page .trafico-mobile-observation-label i {\n    color: #006699;\n    font-size: 17px;\n    flex: 0 0 auto;\n  }\n\n  .trafico-page .trafico-mobile-observation-value {\n    min-width: 0;\n    margin-top: 5px;\n    padding-left: 23px;\n    line-height: 1.4;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .trafico-page .trafico-mobile-state-row {\n    justify-content: space-between;\n    gap: 12px;\n    margin-top: 10px;\n    font-size: 13px;\n  }\n\n  .trafico-page .trafico-mobile-state-row span:first-child {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .trafico-page .trafico-status-icons {\n    flex-wrap: wrap;\n    gap: 10px;\n    min-height: 28px;\n    margin-top: 12px;\n  }\n\n  .trafico-page .trafico-status-icons img {\n    flex: 0 0 auto;\n    object-fit: contain;\n  }\n\n  .trafico-page .trafico-mobile-details {\n    margin-top: 12px;\n    padding: 10px;\n    border-radius: 10px;\n    background: #eef6fb;\n    font-size: 12px;\n  }\n\n  .trafico-page .trafico-mobile-details p {\n    margin: 4px 0;\n  }\n\n  .trafico-page .trafico-mobile-bottom-nav {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1005;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    min-height: 62px;\n    padding: 6px 8px calc(6px + env(safe-area-inset-bottom));\n    border-top: 1px solid #dce6f2;\n    background: rgba(255, 255, 255, 0.97);\n    box-shadow: 0 -4px 16px rgba(31, 55, 80, 0.08);\n    transform: translateY(0);\n    opacity: 1;\n    transition: transform 220ms ease, opacity 180ms ease;\n    will-change: transform, opacity;\n  }\n\n  .trafico-page .trafico-mobile-bottom-nav.is-hidden {\n    transform: translateY(calc(100% + env(safe-area-inset-bottom)));\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .trafico-page .trafico-mobile-bottom-nav a,\n  .trafico-page .trafico-mobile-bottom-nav button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 44px;\n    min-height: 44px;\n    flex-direction: column;\n    gap: 2px;\n    border: 0;\n    background: transparent;\n    color: #647b91;\n    font: inherit;\n    font-size: 11px;\n    text-decoration: none;\n  }\n\n  .trafico-page .trafico-mobile-bottom-nav i {\n    font-size: 21px;\n    line-height: 1;\n  }\n\n  .trafico-page .trafico-mobile-bottom-nav .active {\n    color: #006699;\n    font-weight: 700;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .trafico-page .trafico-mobile-bottom-nav {\n      transition: none;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-page {\n    min-height: 100dvh;\n    background: #f5f7fb;\n  }\n\n  .trafico-page .content-wrapper {\n    padding: 0 16px calc(86px + env(safe-area-inset-bottom));\n  }\n\n  .trafico-page .container-fluid.container-p-y {\n    padding-top: 18px !important;\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .trafico-page .container-fluid.container-p-y > .row:first-child {\n    display: block;\n  }\n\n  .trafico-page .container-fluid.container-p-y > .row:first-child > div {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .trafico-page .label_trafico {\n    display: inline-flex;\n    align-items: center;\n    margin: 8px 8px 18px 0 !important;\n    color: #294663;\n    font-size: 22px !important;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  .trafico-page .countersColorsTrafico {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    gap: 12px 10px;\n    width: min(100%, 300px);\n    max-width: 300px;\n    margin: 0 auto 24px;\n    padding: 0;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid > div,\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {\n    flex: 0 0 52px;\n    width: 52px;\n    height: 82px;\n    margin: 0;\n    border: 1px solid #e4e9f0;\n    border-radius: 15px;\n    background: #fff;\n    box-shadow: 0 5px 14px rgba(37, 61, 86, 0.12);\n  }\n\n  .trafico-page .countersColorsTrafico .notification {\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    gap: 3px;\n  }\n\n  .trafico-page .countersColorsTrafico .notification img {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n  }\n\n  .trafico-page .countersColorsTrafico .notificationCount {\n    position: static;\n    width: auto;\n    height: auto;\n    color: #38516d;\n    font-size: 17px;\n    line-height: 1;\n  }\n\n  .trafico-page #FilterIconTrafico {\n    margin: 0 0 20px;\n  }\n\n  .trafico-page #FilterIconTrafico .input-group {\n    min-height: 52px;\n    border: 1px solid #dce5ef;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);\n    overflow: hidden;\n  }\n\n  .trafico-page #FilterIconTrafico .input-group-text,\n  .trafico-page #FilterIconTrafico input {\n    border: 0;\n    background: #fff;\n  }\n\n  .trafico-page #FilterIconTrafico input {\n    min-width: 0;\n    font-size: 16px;\n  }\n\n  .trafico-page #FilterIconTrafico input::placeholder {\n    color: #9aabbc;\n  }\n\n  .trafico-page #FilterIconTrafico .filterTraficCss button {\n    border: 1px solid #7188a0;\n    border-radius: 12px;\n    background: #fff;\n    color: #45627d;\n  }\n\n  .trafico-page .trafico-mobile-card {\n    padding: 16px;\n    border-radius: 20px;\n    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.1);\n  }\n\n  .trafico-page .trafico-mobile-company strong {\n    font-size: 16px;\n  }\n\n  .trafico-page .trafico-mobile-company span {\n    font-size: 15px;\n  }\n\n  .trafico-page .trafico-mobile-meta {\n    color: #334d68;\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .trafico-page .trafico-mobile-status {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px 12px;\n    border-radius: 999px;\n    font-weight: 700;\n  }\n\n  .trafico-page .trafico-mobile-status::before {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    content: \"\";\n  }\n\n  .trafico-page .trafico-mobile-status.is-moving {\n    background: #e7f7ef;\n    color: #159447;\n  }\n\n  .trafico-page .trafico-mobile-status.is-moving::before {\n    background: #159447;\n  }\n\n  .trafico-page .trafico-mobile-status.is-stopped {\n    background: #fde8ec;\n    color: #dc3545;\n  }\n\n  .trafico-page .trafico-mobile-status.is-stopped::before {\n    background: #dc3545;\n  }\n\n  .trafico-page .trafico-mobile-status.is-neutral {\n    background: #eef3f7;\n    color: #45627d;\n  }\n\n  .trafico-page .trafico-mobile-status.is-neutral::before {\n    background: #7890a6;\n  }\n\n  .trafico-page .trafico-mobile-state-row {\n    align-items: center;\n  }\n\n  .trafico-page .trafico-mobile-state-row > span:last-child {\n    color: #45627d;\n    font-size: 14px;\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 1199px) {\n  .trafico-page .cardContainerTrafico {\n    display: none !important;\n  }\n\n  .trafico-page .cardContainerTrafico2 {\n    display: block !important;\n    width: 100%;\n    margin-top: 12px;\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .trafico-page .trafico-responsive-view {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    width: 100%;\n  }\n\n  .trafico-page .trafico-responsive-loading {\n    display: flex !important;\n    min-height: 240px;\n  }\n\n  .trafico-page .trafico-responsive-card {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    min-width: 0;\n    margin: 0;\n    padding: 10px 12px;\n    border: 1px solid #dce6f2;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .trafico-page .trafico-responsive-card + .trafico-responsive-card {\n    border-top: 0;\n  }\n\n  .trafico-page .trafico-responsive-card .infoEmpresaContrato {\n    display: grid;\n    grid-template-columns: minmax(180px, 1.25fr) minmax(110px, 0.8fr) minmax(150px, 1fr) minmax(130px, 0.9fr) minmax(120px, 0.9fr);\n    align-items: center;\n    gap: 4px 16px;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .trafico-page .trafico-responsive-card .opcionesContrato {\n    grid-column: 1 / -1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 0;\n  }\n\n  .trafico-page .trafico-responsive-card .opcionesContrato h5,\n  .trafico-page .trafico-responsive-card .infoEmpresaContrato p {\n    min-width: 0;\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .trafico-page .trafico-responsive-card .infoEmpresaContrato span {\n    font-weight: 600;\n  }\n\n  .trafico-page .trafico-responsive-card .iconsContrato {\n    flex: 0 0 auto;\n  }\n\n  .trafico-page .trafico-responsive-card .moreInfoStyles {\n    flex-basis: 100%;\n  }\n\n  .trafico-page .countersColorsTrafico {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-content: center;\n    width: 300px;\n    max-width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-x: visible;\n    overflow-y: hidden;\n    gap: 8px;\n    padding: 4px 2px 8px;\n  }\n\n  .trafico-page .countersColorsTrafico {\n    display: block;\n    width: 100%;\n    max-width: 360px;\n    margin: 0 auto 18px;\n    padding: 14px 12px 12px;\n    border: 1px solid #e5edf6;\n    border-radius: 18px;\n    background: #fff;\n    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.06);\n    overflow: hidden;\n  }\n\n  .trafico-page .countersColorsTrafico > div {\n    margin-right: 0;\n  }\n\n  .trafico-page .trafico-alerts-mobile-heading {\n    display: block;\n    margin: 0 0 10px;\n    text-align: left;\n  }\n\n  .trafico-page .trafico-alerts-mobile-heading h2 {\n    margin: 0;\n    color: #122f52;\n    font-size: 21px;\n    font-weight: 800;\n    line-height: 1.15;\n  }\n\n  .trafico-page .trafico-alerts-mobile-heading p {\n    display: none;\n  }\n\n  .trafico-page .trafico-alerts-summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    min-height: 44px;\n    margin: 0 0 8px;\n    padding: 4px 10px;\n    border: 1px solid #b9ddff;\n    border-radius: 999px;\n    background: #edf7ff;\n    color: #1265bd;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  .trafico-page .trafico-alerts-summary:hover,\n  .trafico-page .trafico-alerts-summary:focus-visible {\n    background: #e3f2ff;\n    box-shadow: 0 5px 16px rgba(29, 113, 191, 0.12);\n    outline: none;\n  }\n\n  .trafico-page .trafico-alerts-summary-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    background: #d8edff;\n    font-size: 17px;\n  }\n\n  .trafico-page .trafico-alerts-summary-copy {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 5px;\n    margin: 0 auto 0 8px;\n  }\n\n  .trafico-page .trafico-alerts-summary-copy strong {\n    color: #096fd4;\n    font-size: 14px;\n    line-height: 1;\n  }\n\n  .trafico-page .trafico-alerts-summary-copy span {\n    color: #42678b;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .trafico-page .trafico-alerts-summary > i {\n    flex: 0 0 auto;\n    font-size: 18px;\n  }\n\n  .trafico-page .trafico-alerts-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n    width: 100%;\n    max-height: 1000px;\n    opacity: 1;\n    overflow: hidden;\n    transition: max-height 0.2s ease, opacity 0.2s ease, transform 0.2s ease;\n  }\n\n  .trafico-page .trafico-alerts-grid.is-compact {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 8px;\n    max-height: 76px;\n    padding: 1px 0 4px;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .trafico-page .trafico-alerts-grid.is-compact::-webkit-scrollbar {\n    display: none;\n  }\n\n  .trafico-page .trafico-alerts-grid.is-expanded {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 8px;\n    max-height: 360px;\n    overflow: visible;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid > div,\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {\n    display: flex;\n    flex: none;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    min-width: 0;\n    height: auto;\n    min-height: 66px;\n    margin: 0;\n    padding: 5px 4px;\n    border: 1px solid #e3eaf2;\n    border-radius: 11px;\n    background: #fff;\n    box-shadow: 0 4px 12px rgba(37, 61, 86, 0.09);\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification {\n    gap: 2px;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification img,\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification > .badge,\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification > .en-vivo-live-dot {\n    flex: 0 0 auto;\n    transform: scale(0.9);\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notification img {\n    width: 26px !important;\n    height: 26px !important;\n    object-fit: contain;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .notificationCount {\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid.is-compact .counterItem {\n    flex: 0 0 clamp(68px, 19vw, 74px);\n    width: clamp(68px, 19vw, 74px);\n    min-height: 66px;\n    height: 66px;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem:focus-visible {\n    outline: 2px solid #1687e8;\n    outline-offset: 2px;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem {\n    cursor: pointer;\n    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  .trafico-page .countersColorsTrafico .trafico-alerts-grid .counterItem.active {\n    border-color: #63afe4;\n    background: #e8f4ff;\n    box-shadow: 0 4px 12px rgba(0, 102, 153, 0.22);\n  }\n\n  .trafico-page #FilterIconTrafico {\n    display: flex;\n    flex-wrap: nowrap !important;\n    align-items: center;\n    width: 100%;\n    min-width: 0;\n    gap: 8px;\n    margin-bottom: 12px;\n  }\n\n  .trafico-page #FilterIconTrafico .FilterSearchTraficc {\n    flex: 1 1 auto;\n    min-width: 0;\n    margin: 0 !important;\n  }\n\n  .trafico-page #FilterIconTrafico .filterTraficCss {\n    display: flex;\n    flex: 0 0 auto;\n    gap: 8px;\n  }\n\n  .trafico-page #FilterIconTrafico .filterTraficCss button {\n    min-width: 44px;\n    min-height: 44px;\n    margin: 0 !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-page .trafico-responsive-view {\n    gap: 12px;\n    padding: 0 12px calc(80px + env(safe-area-inset-bottom));\n  }\n\n  /* Compensa el espacio interno del contenedor de resultados para que las\n     tarjetas queden visualmente alineadas con el buscador y sus controles. */\n  .trafico-page .trafico-mobile-card {\n    width: calc(100% + 32px);\n    margin-left: -16px;\n    box-sizing: border-box;\n  }\n\n  .trafico-page .trafico-responsive-card {\n    display: block;\n    padding: 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(31, 55, 80, 0.08);\n  }\n\n  .trafico-page .trafico-responsive-card .opcionesContrato {\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .trafico-page .trafico-responsive-card .opcionesContrato h5 {\n    font-size: 14px;\n    line-height: 1.3;\n  }\n\n  .trafico-page .trafico-responsive-card .infoEmpresaContrato p {\n    margin: 8px 0 0;\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  .trafico-page .trafico-responsive-card .infoEmpresaContrato span,\n  .trafico-page .trafico-responsive-card .moreInfoStyles span {\n    font-weight: 600;\n  }\n\n  .trafico-page .trafico-responsive-card .iconsContrato {\n    margin-top: 12px;\n  }\n\n  .trafico-page .trafico-responsive-card .moreInfoStyles {\n    margin-top: 12px;\n  }\n\n  .trafico-page .content-wrapper {\n    padding-bottom: calc(72px + env(safe-area-inset-bottom));\n  }\n\n}\n\n@media (max-width: 767px) {\n  /* Tres filas en móvil: empresas, búsqueda y acciones. */\n  .trafico-page #FilterIconTrafico {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .trafico-page #FilterIconTrafico .trafico-company-filter,\n  .trafico-page #FilterIconTrafico .FilterSearchTraficc,\n  .trafico-page #FilterIconTrafico .filterTraficCss {\n    width: 100%;\n    min-width: 0;\n    flex: 0 0 auto;\n    margin: 0 !important;\n  }\n\n  .trafico-page #FilterIconTrafico .filterTraficCss {\n    justify-content: center;\n  }\n\n  .trafico-page #FilterIconTrafico .trafico-company-select__control {\n    height: 52px;\n    min-height: 52px;\n    border: 1px solid #dce5ef !important;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06) !important;\n  }\n\n  .trafico-page #FilterIconTrafico .trafico-company-select__value-container,\n  .trafico-page #FilterIconTrafico .trafico-company-select__indicators {\n    height: 50px;\n  }\n\n  .trafico-page #FilterIconTrafico .trafico-company-select__placeholder {\n    color: #9aabbc;\n    font-size: 16px;\n  }\n\n  /* El menú de cada tarjeta debe quedar por encima del selector global. */\n  .trafico-page .trafico-company-filter {\n    z-index: 10;\n  }\n\n  .trafico-page .trafico-responsive-menu {\n    position: relative;\n    z-index: 5000;\n  }\n\n  .trafico-page .trafico-responsive-menu .dropdown-menu {\n    z-index: 5001 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
